import { Injectable } from '@angular/core';
import { Http, RequestOptions, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ApiService } from '../api.service';
import { IService } from '../interfaces/iservice';
import { ApiQueryParams } from '../api/api-query-params';
import { SelectionScheduled, SelectionScheduledNew, RevenueIntelligence5Market } from 'ri-api-client';
import * as objectPath from 'object-path';
import * as popsicle from 'popsicle';

@Injectable()
export class SelectionScheduledService implements IService {
    public selectionScheduled: SelectionScheduled.SelectionScheduled[] = [];
    public actionTypes: any[] = [];
    public soccsTypes: any[] = [];
    public soTypes: any[] = [];
    public ccsgroupTypes: any[] = [];
    private options: RequestOptions;

    constructor(private apiService: ApiService) {
        const headers = new Headers({ 'Content-Type': 'application/json' });
        this.options = new RequestOptions({ headers: headers });
        this.apiService.init();
    }

    getSelection(id: number): Observable<SelectionScheduled.SelectionScheduled> {
        return this.apiService.client.selectionsScheduled
            .id(id.toString())
            .GET()
            .map(res => {
                return this.apiService.handleResponse(res);
            });
    }

    post(selectionScheduled: SelectionScheduledNew.SelectionScheduledNew): Observable<SelectionScheduled.SelectionScheduled> {
        return this.apiService.client.selectionsScheduled
            .POST(selectionScheduled, this.options)
            .map(res => {
                return this.apiService.handleResponse(res);
            });
    }

    update(id: number, selectionScheduled: SelectionScheduledNew.SelectionScheduledNew): Observable<SelectionScheduled.SelectionScheduled> {
        return this.apiService.client.selectionsScheduled
            .id(id.toString())
            .PATCH(selectionScheduled, this.options)
            .map(res => {
                return this.apiService.handleResponse(res);
            });
    }

    delete(selectionId: number) {
        return this.apiService.client.selectionsScheduled
            .id(selectionId.toString())
            .DELETE(this.options)
            .map(res => {
                return this.apiService.handleResponse(res);
            });
    }

    getAll(query: ApiQueryParams): Observable<any> {
        return this.apiService.client.selectionsScheduled.GET(query.fields, query.filter, query.group, query.aggregatedFields, query.sort, query.page, query.skip, query.take)
            .map((res) => {
                return (this.selectionScheduled = this.apiService.handleResponse(res));
            });
    }

    getCount(filter: string): Observable<any> {
        return this.getAll({
            filter: filter,
            aggregatedFields: 'Count()'
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/core/api/selections-scheduled.service.ts